import { render, staticRenderFns } from "./CardRepairGuides.vue?vue&type=template&id=57b3d6e8&scoped=true&"
import script from "./CardRepairGuides.vue?vue&type=script&lang=js&"
export * from "./CardRepairGuides.vue?vue&type=script&lang=js&"
import style0 from "./CardRepairGuides.vue?vue&type=style&index=0&id=57b3d6e8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b3d6e8",
  null
  
)

export default component.exports